<div>
   <p class="paragraph">
    El cliente declara que, previo a proporcionar su información, ha tenido a su disposición el Aviso de Privacidad Integral de Telcel, el cual puede consultar en cualquier momento en <a class="link" href="https://www.telcel.com/aviso-de-privacidad" target="_blank" rel="noopener noreferrer">www.telcel.com/aviso-de-privacidad</a>
  </p>
</div>
